import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

let lastPageKey = 'default';

export default function useScrollRestoration(pageKey) {
    const [yPosition, setYPosition] = useState(0);
    let { pathname } = useLocation();

    useEffect(() => {
        if (pageKey && lastPageKey != pageKey) {
            lastPageKey = pageKey;
            setYPosition(0);
        }
    }, [pageKey, lastPageKey]);

    useEffect(() => {
        return () => {
            setYPosition(window.scrollY || 0);
        };
    }, [pathname]);

    useEffect(() => {
        window.scrollTo(0, yPosition || 0);
    }, [yPosition, pathname]);
}
